export const API_URL = "https://forkify-api.herokuapp.com/api/v2/recipes"
export const TIMEOUT_SEC = 10
export const RESULTS_PER_PAGE = 10
export const KEY = "7069a7b3-cb78-425f-842e-8598b25e1920"
export const MODAL_CLOSE_SEC = 2.5
